import gsap from 'gsap';

export function initMobileMenu() {
    const mobileNav = document.querySelectorAll('.m-mobile-nav');
    const triggers = document.querySelectorAll('.js-toggle-mobile-menu');
    const overlay = document.querySelector('.m-mobile-nav__overlay');
    const bottomBar = document.querySelector('.m-mobile-nav__bar');
    const links = document.querySelectorAll('.mobile-link');
    const closeBtn = document.querySelector('.m-mobile-nav__close');

    //Effacer les autres logo Crépuscule quand on ouvre le menu mobile
    const otherLogos = document.querySelectorAll('.o-home-hero__logo, .mobile_only-logo');

    if (!overlay) return;

    let isOpen = false;

    // Timeline GSAP (en pause au début)
    const tl = gsap.timeline({ paused: true });

    tl
    .to(otherLogos, {
        duration: 0.8,
        autoAlpha: 0,
        ease: "power4.inOut"
    }, "<") // commence en même temps que l'animation du menu
    // 1. Apparition du fond blanc
    .to(mobileNav, {
        duration: 0.8,
        width: "80%",
        backgroundColor: "#fff",
        ease: "power4.inOut"
    }, "<")
    .to(overlay, { 
        duration: 0.8, 
        autoAlpha: 1, 
        height: "auto",
        ease: "power4.inOut" 
    }, "<")
    // 2. Disparition de la barre orange (vers le bas)
    .to(bottomBar, {
        duration: 0.8,
        y: 100,
        height: 0,
        ease: "power4.inOut",
    }, "<") // commence en même temps
    // 3. Apparition des liens en cascade
    .to(links, {
        duration: 0.5,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: "back.out(1.7)"
    }, "-=0.2")
    // 4. Apparition du bouton fermer (Pop effect)
    .from(closeBtn, {
        duration: 0.5,
        opacity: 1,
        y: 0,
        stagger: 0.1,
        ease: "back.out(1.7)"
    }, "-=0.4");

    // Gestion du click
    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            
            if (!isOpen) {
                tl.play();
                document.body.style.overflow = 'hidden'; // Bloque le scroll
            } else {
                tl.reverse();
                document.body.style.overflow = ''; // Réactive le scroll
            }
            
            isOpen = !isOpen;
        });
    });
}

// Lancer la fonction au chargement
initMobileMenu();